Vue.component('taskComponent', {
    template: templates.taskComponent,
    props: ['index', 'taskIndex', 'existingTask', 'id', 'packs', 'cards', 'temporaryCards'],
    data() {
        return {
            model: {
                eventIndex: null,
                rewards: {},
                barks: false,
                xp: false,
                randomCard: false,
                selectedCard: false,
                eventCard: false,
                give_pack: false,
                frames: false,
                task: null,
                id: null,
                cards: {},
                event_cards: {},
                packs: {},
                randomcard: [
                    {
                        name: '-- Select Card Type --'
                    },
                    {
                        name: 'Standard Card'
                    },
                    {
                        name: 'Ultra Card'
                    },
                    {
                        name: 'Legendary Card'
                    },
                    {
                        name: 'Ultimate Card'
                    },
                    {
                        name: 'Bone Card'
                    },
                    {
                        name: 'Ascension Card'
                    }
                ],
            },
            isDragging: false
        }
    },
    watch: {
        cards(val) {
            if (val) this.model.cards = val;
        },
        packs(val) {
            if (val) this.model.packs = val;
        },
        temporaryCards(val) {
            if (val) this.model.event_cards = val;
        }
    },
    mounted() {
        const c = this;

        if (c.existingTask) {
            c.populateFromExisting();
        } else {
            c.isEditing = true;
        }

        if (c.cards) c.model.cards = c.cards;
        if (c.packs) c.model.packs = c.packs;
        if (c.temporaryCards) c.model.event_cards = c.temporaryCards;
    },
    methods: {
        populateFromExisting() {
            const c = this;
            if (!c.existingTask) return;

            const rewards = c.existingTask.rewards || {};
            c.model.task = c.existingTask.taskName || c.existingTask.task;
            c.model.id = c.id;
            c.model.rewards = { ...rewards };

            // Set checkboxes based on existing rewards
            c.model.barks = !!rewards.barks;
            c.model.xp = !!rewards.xp;
            c.model.selectedCard = !!(rewards.selectedCard && rewards.selectedCard.length > 0);
            c.model.randomCard = !!(rewards.randomCard && rewards.randomCard.length > 0);
            c.model.give_pack = !!(rewards.givePack && rewards.givePack.length > 0);
            c.model.eventCard = !!(rewards.eventCard && rewards.eventCard.length > 0);

            // Initialize counter fields if they don't exist but arrays do
            if (rewards.givePack && rewards.givePack.length > 0 && !rewards.packs_amount) {
                c.$set(c.model.rewards, 'packs_amount', rewards.givePack.length - 1);
            }

            if (rewards.randomCard && rewards.randomCard.length > 0 && !rewards.random_amount) {
                c.$set(c.model.rewards, 'random_amount', rewards.randomCard.length - 1);
            }

            if (rewards.selectedCard && rewards.selectedCard.length > 0 && !rewards.cards_amount) {
                c.$set(c.model.rewards, 'cards_amount', rewards.selectedCard.length - 1);
            }

            if (rewards.eventCard && rewards.eventCard.length > 0 && !rewards.event_cards_amount) {
                c.$set(c.model.rewards, 'event_cards_amount', rewards.eventCard.length - 1);
            }


            console.log(c.model.selectedCard)

        },
        // updateField(field, value) {
        //     const c = this;
        //     c.$emit('input-changed', { 
        //         model: { 
        //             ...c.model, 
        //             [field]: value 
        //         } 
        //     });
        // },
        updateField(field, value) {
            this.model[field] = value;
            this.$emit('input-changed', {
                task: this.model.task,
                rewards: this.model.rewards
            }); // Emit changes to parent
        },
        handleRewardChange(rewardData) {
            this.model.rewards = { ...this.model.rewards, ...rewardData };


            this.$emit('input-changed', {
                task: this.model.task,
                rewards: this.model.rewards
            }); // Emit changes to parent


            console.log(rewardData)

        },
        getCards() {
            const c = this;
            return new Promise((resolve, reject) => {
                cardService.get()
                    .then(function (response) {
                        let data = {};
                        for (let d of response.data) {
                            data[`${d.id}`] = d;
                        }

                        c.$set(c.model, 'cards', data);
                        console.log('Cards loaded:', Object.keys(data).length);
                        resolve(data);
                    })
                    .catch(function (error) {
                        console.error('Error loading cards:', error);
                        reject(error);
                    });
            });
        },
        getPack() {
            const c = this;
            return new Promise((resolve, reject) => {
                packService.get()
                    .then(function (response) {
                        let data = {};
                        for (let d of response.data) {
                            data[`${d.id}`] = d;
                        }

                        c.$set(c.model, 'packs', data);
                        console.log('Packs loaded:', Object.keys(data).length);
                        resolve(data);
                    })
                    .catch(function (error) {
                        console.error('Error loading packs:', error);
                        reject(error);
                    });
            });
        },
        saveTask(index, taskIndex) {
            const c = this;
            if (Object.keys(c.model.rewards).length === 0) {
                utils.alert.error('Select Rewards')
                return;
            }
            const taskData = {
                id: c.id,
                task: c.model.task,
                rewards: c.model.rewards,
                eventId: index,
                taskIndex: taskIndex
            };

            eventsService.save(taskData)
                .then(function (response) {
                    c.$emit('update-task', taskData, c.index, taskIndex);
                })
                .catch(function (error) {
                    utils.alert.error('Failed to save.');
                });

        },
        removeTask(index, taskIndex) {
            const c = this;
            c.$emit('remove-task', c.index, taskIndex);
        },
        openRewardsModule(taskIndex) {
            const c = this;

            if (c.model.eventIndex == taskIndex) {
                c.model.eventIndex = null
                return;
            }

            c.model.eventIndex = taskIndex

        },
        selectReward(type) {
            const c = this;

            if (type === 'barks') {
                c.model.barks = !c.model.barks
                if (c.model.barks) {
                    c.$set(c.model.rewards, 'barks', '0')
                }
                else {
                    c.$delete(c.model.rewards, 'barks')
                }
            }

            if (type === 'xp') {
                c.model.xp = !c.model.xp
                if (c.model.xp) {
                    c.$set(c.model.rewards, 'xp', '0')
                }
                else {
                    c.$delete(c.model.rewards, 'xp')
                }
            }

            if (type === 'pack') {

                c.model.give_pack = !c.model.give_pack

                if (c.model.give_pack) {
                    c.$set(c.model.rewards, 'packs_amount', 0)
                    c.$set(c.model.rewards, 'givePack', [{ packId: null, packs_quantity: 0 }])
                }
                else {
                    c.$delete(c.model.rewards, 'givePack')
                    c.$delete(c.model.rewards, 'packs_amount')
                }
            }

            if (type === 'randomcard') {
                c.model.randomCard = !c.model.randomCard
                if (c.model.randomCard) {
                    c.$set(c.model.rewards, 'randomCard', [{ randomCard: 0, random_amount: 0 }])
                }
                else {
                    c.$delete(c.model.rewards, 'randomCard')
                }
            }

            if (type === 'card') {
                c.model.selectedCard = !c.model.selectedCard
                if (c.model.selectedCard) {
                    c.$set(c.model.rewards, 'selectedCard', [{ cardId: null, card_amount: 0, card_tier: 0 }])
                }
                else {
                    c.$delete(c.model.rewards, 'selectedCard')
                }
            }
            
            if (type === 'event_card') {
                c.model.eventCard = !c.model.eventCard
                if (c.model.eventCard) {
                    c.$set(c.model.rewards, 'eventCard', [{ id: null, card_amount: 0, card_tier: 0 }])
                }
                else {
                    c.$delete(c.model.rewards, 'eventCard')
                }
            }

            this.$emit('input-changed', {
                task: this.model.task,
                rewards: this.model.rewards
            });

        },
        onDragStart(event) {
            const c = this
            this.isDragging = true;
            event.dataTransfer.setData('text/plain', JSON.stringify({
                taskId: c.id,
                taskIndex: c.taskIndex,
                eventIndex: c.index
            }));
            event.dataTransfer.effectAllowed = 'move';
        },
        
        onDragOver(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
        },
        
        onDrop(event) {
            const c = this;
            event.preventDefault();
            const dragData = JSON.parse(event.dataTransfer.getData('text/plain'));

            if (dragData.taskId !== c.id && dragData.eventIndex === c.index) {

                c.$emit('reorder-tasks', {
                fromIndex: dragData.taskIndex,
                toIndex: c.taskIndex,
                eventIndex: c.index
                });

            }
        },
        
        onDragEnd(event) {
            this.isDragging = false;
        }
        
    }

});